import React, { useState, useMemo } from 'react';
import { Search, ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * BarraAgende — la colonna di sinistra dell'agenda.
 *
 * Sostituisce il vecchio pannello a comparsa "Colonne": con quaranta
 * agende serve averle sott'occhio mentre si guarda la griglia, non
 * dietro un pulsante.
 *
 * La spunta governa due cose diverse a seconda di chi si tocca:
 * togliendola a chi lavora oggi si nasconde la colonna, mettendola a
 * chi non lavora la si aggiunge (e la griglia si ricarica, perche' i
 * suoi appuntamenti li conosce solo il server).
 */
const BarraAgende = ({ tutte, idsInGriglia, nascoste, extra, onCommuta, colore }) => {
    const [cerca, setCerca] = useState('');
    const [spec, setSpec] = useState('');
    const [soloOggi, setSoloOggi] = useState(true);
    const [chiusa, setChiusa] = useState(false);

    const specializzazioni = useMemo(() => {
        const s = new Set();
        tutte.forEach((a) => { if (a.specializzazione) s.add(a.specializzazione); });
        return [...s].sort();
    }, [tutte]);

    const elenco = useMemo(() => {
        const q = cerca.trim().toLowerCase();
        return tutte.filter((a) => {
            if (soloOggi && !idsInGriglia.includes(a.id) && !extra.includes(a.id)) return false;
            if (spec && a.specializzazione !== spec) return false;
            if (!q) return true;
            return `${a.cognome || ''} ${a.medico_nome || ''} ${a.nome}`.toLowerCase().includes(q);
        });
    }, [tutte, cerca, spec, soloOggi, idsInGriglia, extra]);

    if (chiusa) {
        return (
            <button className="ag-barra-riapri" onClick={() => setChiusa(false)} title="Mostra le agende">
                <ChevronRight size={16} />
            </button>
        );
    }

    return (
        <aside className="ag-barra">
            <div className="ag-barra-testa">
                <b>Agende</b>
                <button onClick={() => setChiusa(true)} title="Nascondi">
                    <ChevronLeft size={16} />
                </button>
            </div>

            <select value={spec} onChange={(e) => setSpec(e.target.value)} className="ag-barra-spec">
                <option value="">Tutte le specializzazioni</option>
                {specializzazioni.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>

            <div className="ag-barra-cerca">
                <Search size={14} />
                <input
                    value={cerca}
                    onChange={(e) => setCerca(e.target.value)}
                    placeholder="Cerca per agenda"
                />
            </div>

            <label className="ag-barra-oggi">
                <span>Lavorano oggi</span>
                <button
                    type="button"
                    className={`ag-switch ${soloOggi ? 'on' : ''}`}
                    onClick={() => setSoloOggi(!soloOggi)}
                >
                    <span />
                </button>
            </label>

            <div className="ag-barra-lista">
                {!elenco.length && <p className="ag-barra-vuoto">Nessuna agenda</p>}
                {elenco.map((a) => {
                    const dentro = (idsInGriglia.includes(a.id) || extra.includes(a.id))
                        && !nascoste.includes(a.id);
                    const c = colore(a.id);
                    return (
                        <label key={a.id} className="ag-barra-voce">
                            <input
                                type="checkbox"
                                checked={dentro}
                                onChange={(e) => onCommuta(a.id, e.target.checked)}
                            />
                            <span
                                className="ag-barra-quadro"
                                style={{ borderColor: c, background: dentro ? c : 'transparent' }}
                            />
                            <span className="ag-barra-nome">
                                {a.cognome ? `${a.cognome}, ${a.medico_nome}` : a.nome}
                            </span>
                            {!a.ha_orari && <em title="Nessun orario impostato">·</em>}
                        </label>
                    );
                })}
            </div>
        </aside>
    );
};

export default BarraAgende;
